module.exports = __webpack_public_path__ + "img/P25-en.4dbf0d35.png";